(function () {
  "use strict";

  var NAME_PLATE_VARIANT_ID = 47834729939082;
  var PLATE_FONT = "License-font";

  class NumberPlatePersonalizer {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.canvas = null;
      this.ctx = null;
      this.imageEl = null;
      this.canvasContainer = null;
      this.displayWidth = 0;
      this.displayHeight = 0;
      this.resizeObserver = null;

      this.state = {
        text: "",
        bgColor: "#FFFFFF",
        textColor: "#000000",
        bgLabel: "White",
        tcLabel: "Black",
        borderColor: "#000000",
        borderLabel: "Black",
      };

      this.plateConfig = {
        x: parseFloat(container.dataset.plateX) || 0.37,
        y: parseFloat(container.dataset.plateY) || 0.54,
        width: parseFloat(container.dataset.plateW) || 0.26,
        height: parseFloat(container.dataset.plateH) || 0.05,
        borderRadius: 3,
        borderWidth: 2,
      };

      this.init();
    }

    init() {
      this.bindControls();
      this.setupCanvas();
      this.setupSwitchToFrontImage();
      this.setupPairIdOnSubmit();
      this.setupAutoAddVariant();
      this.setupRemovePairing();
      this.setupQuantitySync();
    }

    static _npGenPairId() {
      return "np_" + Date.now() + "_" + Math.random().toString(36).slice(2, 11);
    }

    /* ───────── Switch media to front image when personalizing ───────── */

    setupSwitchToFrontImage() {
      var self = this;
      var section =
        this.container.closest("product-info") ||
        document.querySelector("product-info");
      if (!section) return;

      var gallery = section.querySelector("media-gallery");
      if (!gallery) return;

      this.switchToFrontImage = function () {
        var frontImg = gallery.querySelector('img[alt="front-image"]');
        if (!frontImg) return;
        var frontSlide = frontImg.closest(".m-product-media--item");
        if (!frontSlide) return;

        var idx = parseInt(frontSlide.dataset.index || "0", 10);
        if (isNaN(idx)) return;

        if (gallery.slider) {
          if (gallery.slider.params.loop && typeof gallery.slider.slideToLoop === "function") {
            gallery.slider.slideToLoop(idx, 300);
          } else if (typeof gallery.slider.slideTo === "function") {
            gallery.slider.slideTo(idx, 300);
          }
        } else {
          frontSlide.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      };
    }

    /* ───────── Controls ───────── */

    bindControls() {
      var self = this;
      var sid = this.sectionId;

      var textInput = document.getElementById("np-text-" + sid);
      var counter = document.getElementById("np-count-" + sid);

      if (textInput) {
        textInput.addEventListener("input", function (e) {
          var v = e.target.value.replace(/[^A-Za-z0-9 ]/g, "").toUpperCase();
          if (v.length > 8) v = v.substring(0, 8);
          e.target.value = v;
          self.state.text = v;
          if (counter) counter.textContent = v.length;
          self.syncProperties();
          self.render();
          if (v.length > 0 && self.switchToFrontImage) self.switchToFrontImage();
        });
        textInput.addEventListener("focus", function () {
          if (self.state.text.length > 0 && self.switchToFrontImage) self.switchToFrontImage();
        });
      }

      this.container
        .querySelectorAll('input[name="np-bg-' + sid + '"]')
        .forEach(function (r) {
          r.addEventListener("change", function (e) {
            self.state.bgColor = e.target.value;
            var sw = e.target.nextElementSibling;
            self.state.bgLabel = sw ? sw.dataset.color : e.target.value;
            self.syncProperties();
            self.render();
            if (self.state.text.length > 0 && self.switchToFrontImage) self.switchToFrontImage();
          });
        });

      this.container
        .querySelectorAll('input[name="np-tc-' + sid + '"]')
        .forEach(function (r) {
          r.addEventListener("change", function (e) {
            self.state.textColor = e.target.value;
            var sw = e.target.nextElementSibling;
            self.state.tcLabel = sw ? sw.dataset.color : e.target.value;
            self.syncProperties();
            self.render();
            if (self.state.text.length > 0 && self.switchToFrontImage) self.switchToFrontImage();
          });
        });

      this.container
        .querySelectorAll('input[name="np-bd-' + sid + '"]')
        .forEach(function (r) {
          r.addEventListener("change", function (e) {
            self.state.borderColor = e.target.value;
            var sw = e.target.nextElementSibling;
            self.state.borderLabel = sw ? sw.dataset.color : e.target.value;
            self.syncProperties();
            self.render();
            if (self.state.text.length > 0 && self.switchToFrontImage) self.switchToFrontImage();
          });
        });
    }

    syncProperties() {
      var sid = this.sectionId;
      var propText = document.getElementById("np-prop-text-" + sid);
      var propBg = document.getElementById("np-prop-bg-" + sid);
      var propTc = document.getElementById("np-prop-tc-" + sid);
      var propBd = document.getElementById("np-prop-bd-" + sid);

      var hasText = this.state.text.trim().length > 0;

      if (propText) {
        propText.value = this.state.text;
        propText.disabled = !hasText;
      }
      if (propBg) {
        propBg.value = this.state.bgLabel;
        propBg.disabled = !hasText;
      }
      if (propTc) {
        propTc.value = this.state.tcLabel;
        propTc.disabled = !hasText;
      }
      if (propBd) {
        propBd.value = this.state.borderLabel;
        propBd.disabled = !hasText;
      }
      var propPair = document.getElementById("np-prop-pair-" + this.sectionId);
      var isNamePlateProduct = this.container.dataset.isNamePlateProduct === "true";
      if (propPair) propPair.disabled = isNamePlateProduct || !hasText;
    }

    setupPairIdOnSubmit() {
      var self = this;
      var section =
        this.container.closest("product-info") ||
        document.querySelector("product-info");
      if (!section) return;
      var form = section.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;
      var isNamePlateProduct = this.container.dataset.isNamePlateProduct === "true";
      form.addEventListener(
        "submit",
        function () {
          var textInput = document.getElementById("np-text-" + self.sectionId);
          var text = textInput
            ? textInput.value.replace(/[^A-Za-z0-9 ]/g, "").toUpperCase().trim()
            : self.state.text.trim();

          if (text.length === 0) return;
          if (!isNamePlateProduct) {
            var pairId = NumberPlatePersonalizer._npGenPairId();
            var propPair = document.getElementById("np-prop-pair-" + self.sectionId);
            if (propPair) {
              propPair.value = pairId;
              propPair.disabled = false;
            }
            document._npLastPairId = pairId;
          }
          var qtyInput = form.querySelector('input[name="quantity"]');
          document._npLastQuantity = (qtyInput && parseInt(qtyInput.value, 10)) || 1;
        },
        true
      );
    }

    /* ───────── Canvas setup ───────── */

    setupCanvas() {
      var self = this;
      var section =
        this.container.closest("product-info") ||
        document.querySelector("product-info");
      if (!section) return;

      var gallery = section.querySelector("media-gallery");
      if (!gallery) return;

      var targetImg = gallery.querySelector('img[alt="front-image"]');
      if (!targetImg) {
        targetImg = gallery.querySelector(
          '.m-product-media--item[data-index="0"] .m-product-media img'
        );
      }
      if (!targetImg) return;

      var mediaContainer = targetImg.closest(".m-product-media");
      if (!mediaContainer) return;

      this.canvasContainer = mediaContainer;
      this.imageEl = targetImg;

      this.canvas = document.createElement("canvas");
      this.canvas.id = "np-canvas-" + this.sectionId;
      this.canvas.className = "np-canvas-overlay";

      var pos = window.getComputedStyle(mediaContainer).position;
      if (pos === "static") mediaContainer.style.position = "relative";

      mediaContainer.appendChild(this.canvas);
      this.ctx = this.canvas.getContext("2d");

      if (this.imageEl.complete && this.imageEl.naturalWidth > 0) {
        this.resizeCanvas();
      }
      this.imageEl.addEventListener("load", function () {
        self.resizeCanvas();
      });

      this.resizeObserver = new ResizeObserver(function () {
        self.resizeCanvas();
      });
      this.resizeObserver.observe(mediaContainer);
    }

    resizeCanvas() {
      if (!this.canvas || !this.imageEl) return;

      var rect = this.imageEl.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return;

      var dpr = window.devicePixelRatio || 1;
      this.canvas.width = rect.width * dpr;
      this.canvas.height = rect.height * dpr;
      this.canvas.style.width = rect.width + "px";
      this.canvas.style.height = rect.height + "px";
      this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      this.displayWidth = rect.width;
      this.displayHeight = rect.height;

      this.render();
    }

    /* ───────── Rendering ───────── */

    drawRoundRect(ctx, x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.lineTo(x + w - r, y);
      ctx.quadraticCurveTo(x + w, y, x + w, y + r);
      ctx.lineTo(x + w, y + h - r);
      ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      ctx.lineTo(x + r, y + h);
      ctx.quadraticCurveTo(x, y + h, x, y + h - r);
      ctx.lineTo(x, y + r);
      ctx.quadraticCurveTo(x, y, x + r, y);
      ctx.closePath();
    }

    render() {
      if (!this.ctx || !this.displayWidth) return;

      var ctx = this.ctx;
      var w = this.displayWidth;
      var h = this.displayHeight;

      ctx.clearRect(0, 0, w, h);

      if (!this.state.text.trim()) return;

      var pc = this.plateConfig;
      var py = h * pc.y;
      var ph = h * pc.height;
      var r = pc.borderRadius;
      var basePw = w * pc.width;
      var centerX = w * pc.x + basePw / 2;

      /* Use ~90% of plate height so text fills vertically with minimal top/bottom spacing */
      var fontSize = Math.max(10, ph * 0.9);
      ctx.font = 'bold ' + fontSize + 'px "' + PLATE_FONT + '", sans-serif';
      var textWidth = ctx.measureText(this.state.text).width;
      var charPadding = textWidth / Math.max(1, this.state.text.length);
      var pw = textWidth + charPadding * 2;
      pw = Math.max(pw, ph * 2);
      pw = Math.min(pw, w * 0.9);
      if (textWidth > pw - charPadding * 2) {
        fontSize = fontSize * ((pw - charPadding * 2) / textWidth);
        ctx.font = 'bold ' + fontSize + 'px "' + PLATE_FONT + '", sans-serif';
        textWidth = ctx.measureText(this.state.text).width;
      }
      var px = centerX - pw / 2;
      px = Math.max(0, Math.min(w - pw, px));

      ctx.save();
      ctx.shadowColor = "transparent";
      ctx.shadowBlur = 0;
      ctx.shadowOffsetY = 0;
      this.drawRoundRect(ctx, px, py, pw, ph, r);
      ctx.fillStyle = this.state.bgColor;
      ctx.fill();
      ctx.restore();

      this.drawRoundRect(ctx, px, py, pw, ph, r);
      ctx.strokeStyle = this.state.borderColor || pc.borderColor || "#222222";
      ctx.lineWidth = pc.borderWidth;
      ctx.stroke();
      /* Draw border inset so stroke doesn't extend outside – removes outer space */
      var bw = pc.borderWidth || 2;
      var ix = bw / 2;
      var iy = bw / 2;
      var iw = pw - bw;
      var ih = ph - bw;
      var ir = Math.max(0, r - ix);
      if (iw > 0 && ih > 0) {
        this.drawRoundRect(ctx, px + ix, py + iy, iw, ih, ir);
        ctx.stroke();
      }

      ctx.fillStyle = this.state.textColor;
      ctx.textAlign = "center";
      ctx.textBaseline = "alphabetic";
      var metrics = ctx.measureText(this.state.text);
      var ascent = metrics.actualBoundingBoxAscent !== undefined ? metrics.actualBoundingBoxAscent : fontSize * 0.8;
      var descent = metrics.actualBoundingBoxDescent !== undefined ? metrics.actualBoundingBoxDescent : fontSize * 0.2;
      /* Uppercase/numeric has no descenders – cap descent to remove excess bottom space & balance top/bottom */
      descent = Math.min(descent, fontSize * 0.02);
      var textCenterY = py + ph / 2;
      var baselineY = textCenterY - (descent - ascent) / 2;
      ctx.fillText(this.state.text, px + pw / 2, baselineY);
    }

    /* ───────── Auto-add Name Plate variant ───────── */

    setupAutoAddVariant() {
      var self = this;

      // assemble-service.js coordinator handles add-ons when both scripts are present
      if (document._addonCoordinatorBound) return;
      if (document._npVariantBound) return;
      document._npVariantBound = true;

      document.addEventListener("product-ajax:added", function (ev) {
        if (!self.state.text.trim()) return;

        var addedVariantId = null;
        var addedProductId = null;
        if (ev && ev.detail && ev.detail.product) {
          var resp = ev.detail.product;
          if (resp.items && resp.items.length > 0) {
            addedVariantId = resp.items[0].variant_id;
            addedProductId = resp.items[0].product_id;
          } else if (resp.variant_id) {
            addedVariantId = resp.variant_id;
            addedProductId = resp.product_id;
          }
        }
        if (addedVariantId && String(addedVariantId) === String(NAME_PLATE_VARIANT_ID)) {
          return;
        }
        var standaloneEl = document.querySelector(".np-personalizer");
        var standaloneProductId = standaloneEl && standaloneEl.dataset.standaloneNamePlateProductId;
        if (standaloneProductId && addedProductId && String(addedProductId) === String(standaloneProductId)) {
          return;
        }

        var pairId = document._npLastPairId;
        var qty = document._npLastQuantity || 1;
        var payload = { id: NAME_PLATE_VARIANT_ID, quantity: qty };
        var props = {};
        if (pairId) props._np_pair_id = pairId;
        props["Number Plate Text"] = self.state.text.trim();
        props["Plate Background Color"] = self.state.bgLabel || "White";
        props["Plate Text Color"] = self.state.tcLabel || "Black";
        props["Plate Border Color"] = self.state.borderLabel || "Black";
        payload.properties = props;

        var addUrl =
          window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_add_url
            ? window.MinimogSettings.routes.cart_add_url
            : "/cart/add.js";
        fetch(addUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, status: res.status, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok) {
              console.error("[NP] FAILED to add Name Plate:", result.status, result.data);
              return;
            }
            document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          })
          .catch(function (err) {
            console.error("[NP] Fetch error:", err);
          });
      });

    }

    /* ───────── Auto-remove Name Plate when Personalizer product removed ───────── */

    setupRemovePairing() {
      if (document._npRemoveBound) return;
      document._npRemoveBound = true;

      var routes = window.MinimogSettings && window.MinimogSettings.routes;
      var baseUrl = routes && routes.cart_change_url ? routes.cart_change_url : "/cart/change";
      var changeUrl = baseUrl.indexOf(".js") === -1 ? baseUrl + ".js" : baseUrl;
      var root = (routes && routes.root) ? String(routes.root).replace(/\/$/, "") : "";
      var cartUrl = root ? root + "/cart.js" : "/cart.js";

      document.addEventListener(
        "click",
        function (e) {
          var btn = e.target.closest("m-cart-remove-button");
          if (!btn) return;

          var line = parseInt(btn.dataset.index || "0", 10);
          if (!line) return;

          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          var cartItemsEl = btn.closest("m-cart-items") || document.querySelector("m-cart-items");
          if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.start();

          fetch(cartUrl)
            .then(function (r) {
              if (!r.ok) throw new Error("Cart fetch failed");
              return r.json();
            })
            .then(function (cart) {
              var item = cart.items[line - 1];
              if (!item) {
                if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
                return;
              }
              var pairId = item.properties && item.properties["_np_pair_id"];
              var isPersonalized = item.properties && item.properties["Number Plate Text"];
              var isNamePlate = String(item.variant_id) === String(NAME_PLATE_VARIANT_ID);

              function doRemove(lineNum) {
                return fetch(changeUrl, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({ line: lineNum, quantity: 0 }),
                }).then(function (r) {
                  return r.json().then(function (data) {
                    if (!r.ok || (data && data.errors)) {
                      var msg = (data && data.description) || (data && data.message) || "Cart update failed";
                      throw new Error(msg);
                    }
                    return data;
                  });
                });
              }

              function refreshCart() {
                if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
                document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
              }

              var pairLine = null;
              /* Only remove both when items share the same _np_pair_id (actual paired toy car + Name Plate). */
              /* Standalone Name Plates (added from Name Plate product page) have no pairId - remove only the clicked item. */
              if (pairId) {
                for (var i = 0; i < cart.items.length; i++) {
                  if (i === line - 1) continue;
                  var other = cart.items[i];
                  var otherPairId = other.properties && other.properties["_np_pair_id"];
                  if (otherPairId === pairId) {
                    pairLine = i + 1;
                    break;
                  }
                }
              }

              if (pairLine) {
                var first = pairLine > line ? pairLine : line;
                var second = pairLine < line ? pairLine : line;
                if (first === second) {
                  return doRemove(line).then(refreshCart);
                }
                return doRemove(first)
                  .then(function () { return new Promise(function (r) { setTimeout(r, 300); }); })
                  .then(function () { return doRemove(second); })
                  .then(refreshCart);
              }
              return doRemove(line).then(refreshCart);
            })
            .catch(function (err) {
              console.warn("[NP] Remove failed:", err);
              if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
            });
        },
        true
      );
    }

    /* ───────── Sync quantity: Personalizer & Name Plate stay matched ───────── */

    setupQuantitySync() {
      if (document._npQtySyncBound) return;
      document._npQtySyncBound = true;

      var routes = window.MinimogSettings && window.MinimogSettings.routes;
      var baseUrl = routes && routes.cart_change_url ? routes.cart_change_url : "/cart/change";
      var changeUrl = baseUrl.indexOf(".js") === -1 ? baseUrl + ".js" : baseUrl;
      var root = (routes && routes.root) ? String(routes.root).replace(/\/$/, "") : "";
      var cartUrl = root ? root + "/cart.js" : "/cart.js";

      document.addEventListener(
        "change",
        function (e) {
          var input = e.target;
          if (input.type !== "number" || !input.dataset.index) return;
          if (!input.closest("m-cart-items") && !input.closest("m-cart")) return;

          var line = parseInt(input.dataset.index || "0", 10);
          var qty = parseInt(input.value, 10);
          if (!line || isNaN(qty) || qty < 0) return;

          var cartItemsEl = document.querySelector("m-cart-items");
          if (!cartItemsEl) return;

          e.preventDefault();
          e.stopPropagation();

          if (cartItemsEl.loading) cartItemsEl.loading.start();

          fetch(cartUrl)
            .then(function (r) {
              if (!r.ok) throw new Error("Cart fetch failed");
              return r.json();
            })
            .then(function (cart) {
              var item = cart.items[line - 1];
              if (!item) {
                if (cartItemsEl.loading) cartItemsEl.loading.finish();
                return;
              }
              var pairId = item.properties && item.properties["_np_pair_id"];
              var isPersonalized = item.properties && item.properties["Number Plate Text"];
              var isNamePlate = String(item.variant_id) === String(NAME_PLATE_VARIANT_ID);

              var pairLine = null;
              if (pairId) {
                for (var i = 0; i < cart.items.length; i++) {
                  if (i === line - 1) continue;
                  var other = cart.items[i];
                  var op = other.properties && other.properties["_np_pair_id"];
                  if (op === pairId) {
                    pairLine = i + 1;
                    break;
                  }
                }
              }
              if (!pairLine && (isPersonalized || isNamePlate)) {
                var idx = line - 1;
                var prev = idx > 0 ? cart.items[idx - 1] : null;
                var next = idx < cart.items.length - 1 ? cart.items[idx + 1] : null;
                if (isPersonalized) {
                  if (prev && String(prev.variant_id) === String(NAME_PLATE_VARIANT_ID)) pairLine = idx;
                  else if (next && String(next.variant_id) === String(NAME_PLATE_VARIANT_ID)) pairLine = idx + 2;
                  else {
                    for (var j = 0; j < cart.items.length; j++) {
                      if (String(cart.items[j].variant_id) === String(NAME_PLATE_VARIANT_ID)) {
                        pairLine = j + 1;
                        break;
                      }
                    }
                  }
                } else if (isNamePlate) {
                  if (prev && prev.properties && prev.properties["Number Plate Text"]) pairLine = idx;
                  else if (next && next.properties && next.properties["Number Plate Text"]) pairLine = idx + 2;
                  else {
                    for (var k = 0; k < cart.items.length; k++) {
                      if (cart.items[k].properties && cart.items[k].properties["Number Plate Text"]) {
                        pairLine = k + 1;
                        break;
                      }
                    }
                  }
                }
              }

              if (!pairLine) {
                pairLine = line;
              }

              function doChange(ln, qt) {
                return fetch(changeUrl, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({ line: ln, quantity: qt }),
                }).then(function (r) {
                  return r.json().then(function (data) {
                    if (!r.ok || (data && data.errors)) {
                      throw new Error((data && data.description) || (data && data.message) || "Cart update failed");
                    }
                    return data;
                  });
                });
              }

              if (pairLine === line) {
                return doChange(line, qty)
                  .then(function () {
                    if (cartItemsEl.loading) cartItemsEl.loading.finish();
                    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
                  })
                  .catch(function (err) {
                    if (cartItemsEl.loading) cartItemsEl.loading.finish();
                    document.dispatchEvent(new CustomEvent("np:qty-nopair", { detail: { line: line, quantity: qty } }));
                  });
              }

              var first = pairLine > line ? pairLine : line;
              var second = pairLine < line ? pairLine : line;
              Promise.all([doChange(first, qty), doChange(second, qty)])
                .then(function () {
                  if (cartItemsEl.loading) cartItemsEl.loading.finish();
                  document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
                })
                .catch(function (err) {
                  if (cartItemsEl.loading) cartItemsEl.loading.finish();
                  console.warn("[NP] Quantity sync failed:", err);
                });
            })
            .catch(function (err) {
              if (cartItemsEl.loading) cartItemsEl.loading.finish();
              console.warn("[NP] Quantity sync failed:", err);
            });
        },
        true
      );
    }

    /* ───────── Sync quantity: Personalizer <-> Name Plate ───────── */

    setupQuantitySync() {
      if (document._npQtySyncBound) return;
      document._npQtySyncBound = true;

      var routes = window.MinimogSettings && window.MinimogSettings.routes;
      var baseUrl = routes && routes.cart_change_url ? routes.cart_change_url : "/cart/change";
      var changeUrl = baseUrl.indexOf(".js") === -1 ? baseUrl + ".js" : baseUrl;
      var root = (routes && routes.root) ? String(routes.root).replace(/\/$/, "") : "";
      var cartUrl = root ? root + "/cart.js" : "/cart.js";

      document.addEventListener(
        "change",
        function (e) {
          var input = e.target;
          if (input.type !== "number" || !input.closest("m-quantity-input")) return;
          if (!input.closest("m-cart-items") && !input.closest("m-cart-drawer")) return;

          var line = parseInt(input.dataset.index || "0", 10);
          var qty = parseInt(input.value, 10) || 0;
          if (!line || qty < 0) return;

          e.stopPropagation();
          e.preventDefault();

          var cartItemsEl = document.querySelector("m-cart-items");
          if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.start();

          fetch(cartUrl)
            .then(function (r) {
              if (!r.ok) throw new Error("Cart fetch failed");
              return r.json();
            })
            .then(function (cart) {
              var item = cart.items[line - 1];
              if (!item) {
                if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
                return;
              }
              var pairId = item.properties && item.properties["_np_pair_id"];
              var isPersonalized = item.properties && item.properties["Number Plate Text"];
              var isNamePlate = String(item.variant_id) === String(NAME_PLATE_VARIANT_ID);

              if (!pairId && !isPersonalized && !isNamePlate) {
                if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
                return;
              }

              var pairLine = null;
              if (pairId) {
                for (var i = 0; i < cart.items.length; i++) {
                  if (i === line - 1) continue;
                  var other = cart.items[i];
                  if ((other.properties && other.properties["_np_pair_id"]) === pairId) {
                    pairLine = i + 1;
                    break;
                  }
                }
              }
              if (!pairLine && (isPersonalized || isNamePlate)) {
                var idx = line - 1;
                var prev = idx > 0 ? cart.items[idx - 1] : null;
                var next = idx < cart.items.length - 1 ? cart.items[idx + 1] : null;
                if (isPersonalized) {
                  if (prev && String(prev.variant_id) === String(NAME_PLATE_VARIANT_ID)) pairLine = idx;
                  else if (next && String(next.variant_id) === String(NAME_PLATE_VARIANT_ID)) pairLine = idx + 2;
                } else if (isNamePlate) {
                  if (prev && prev.properties && prev.properties["Number Plate Text"]) pairLine = idx;
                  else if (next && next.properties && next.properties["Number Plate Text"]) pairLine = idx + 2;
                }
              }

              function doChange(lineNum, quantity) {
                return fetch(changeUrl, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({ line: lineNum, quantity: quantity }),
                }).then(function (r) {
                  return r.json().then(function (data) {
                    if (!r.ok || (data && data.errors)) {
                      throw new Error(data && (data.description || data.message)) || "Cart update failed";
                    }
                    return data;
                  });
                });
              }

              function refresh() {
                if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
                document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
              }

              if (pairLine && pairLine !== line) {
                var first = pairLine > line ? pairLine : line;
                var second = pairLine < line ? pairLine : line;
                doChange(first, qty)
                  .then(function () { return doChange(second, qty); })
                  .then(refresh)
                  .catch(function (err) {
                    console.warn("[NP] Quantity sync failed:", err);
                    refresh();
                  });
              } else {
                doChange(line, qty).then(refresh).catch(function (err) {
                  console.warn("[NP] Quantity change failed:", err);
                  refresh();
                });
              }
            })
            .catch(function (err) {
              console.warn("[NP] Cart fetch failed:", err);
              if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
            });
        },
        true
      );
    }

    /* ───────── Sync quantity: Personalizer <-> Name Plate ───────── */

    setupQuantitySync() {
      if (document._npQuantitySyncBound) return;
      document._npQuantitySyncBound = true;

      var routes = window.MinimogSettings && window.MinimogSettings.routes;
      var baseUrl = routes && routes.cart_change_url ? routes.cart_change_url : "/cart/change";
      var changeUrl = baseUrl.indexOf(".js") === -1 ? baseUrl + ".js" : baseUrl;
      var root = (routes && routes.root) ? String(routes.root).replace(/\/$/, "") : "";
      var cartUrl = root ? root + "/cart.js" : "/cart.js";

      document.addEventListener(
        "change",
        function (e) {
          var input = e.target;
          if (!input || input.type !== "number") return;
          var qtyInput = input.closest("m-quantity-input");
          if (!qtyInput) return;
          var cartContainer = input.closest("m-cart-items") || input.closest("m-cart-drawer") || input.closest("form#cart-drawer-form");
          if (!cartContainer) return;

          var line = parseInt(input.dataset.index || "0", 10);
          if (!line) return;

          var newQty = parseInt(input.value, 10);
          if (isNaN(newQty) || newQty < 0) return;

          e.stopPropagation();
          e.preventDefault();

          var cartItemsEl = document.querySelector("m-cart-items");
          if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.start();

          fetch(cartUrl)
            .then(function (r) {
              if (!r.ok) throw new Error("Cart fetch failed");
              return r.json();
            })
            .then(function (cart) {
              var item = cart.items[line - 1];
              if (!item) {
                if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
                return;
              }
              var pairId = item.properties && item.properties["_np_pair_id"];
              var isPersonalized = item.properties && item.properties["Number Plate Text"];
              var isNamePlate = String(item.variant_id) === String(NAME_PLATE_VARIANT_ID);

              if (!pairId && !isPersonalized && !isNamePlate) {
                if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
                return;
              }

              var pairLine = null;
              if (pairId) {
                for (var i = 0; i < cart.items.length; i++) {
                  if (i === line - 1) continue;
                  var other = cart.items[i];
                  var otherPairId = other.properties && other.properties["_np_pair_id"];
                  if (otherPairId === pairId) {
                    pairLine = i + 1;
                    break;
                  }
                }
              }
              if (!pairLine && (isPersonalized || isNamePlate)) {
                var idx = line - 1;
                var prevItem = idx > 0 ? cart.items[idx - 1] : null;
                var nextItem = idx < cart.items.length - 1 ? cart.items[idx + 1] : null;
                if (isPersonalized) {
                  if (prevItem && String(prevItem.variant_id) === String(NAME_PLATE_VARIANT_ID)) pairLine = idx;
                  else if (nextItem && String(nextItem.variant_id) === String(NAME_PLATE_VARIANT_ID)) pairLine = idx + 2;
                  else {
                    for (var j = 0; j < cart.items.length; j++) {
                      if (String(cart.items[j].variant_id) === String(NAME_PLATE_VARIANT_ID)) {
                        pairLine = j + 1;
                        break;
                      }
                    }
                  }
                } else if (isNamePlate) {
                  if (prevItem && prevItem.properties && prevItem.properties["Number Plate Text"]) pairLine = idx;
                  else if (nextItem && nextItem.properties && nextItem.properties["Number Plate Text"]) pairLine = idx + 2;
                  else {
                    for (var k = 0; k < cart.items.length; k++) {
                      if (cart.items[k].properties && cart.items[k].properties["Number Plate Text"]) {
                        pairLine = k + 1;
                        break;
                      }
                    }
                  }
                }
              }

              function doChange(lineNum, qty) {
                return fetch(changeUrl, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({ line: lineNum, quantity: qty }),
                }).then(function (r) {
                  return r.json().then(function (data) {
                    if (!r.ok || (data && data.errors)) {
                      var msg = (data && data.description) || (data && data.message) || "Cart update failed";
                      throw new Error(msg);
                    }
                    return data;
                  });
                });
              }

              function refreshCart() {
                if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
                document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
              }

              if (pairLine && pairLine !== line) {
                Promise.all([
                  doChange(line, newQty),
                  doChange(pairLine, newQty),
                ])
                  .then(refreshCart)
                  .catch(function (err) {
                    console.warn("[NP] Quantity sync failed:", err);
                    if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
                  });
              } else {
                doChange(line, newQty).then(refreshCart).catch(function (err) {
                  console.warn("[NP] Quantity update failed:", err);
                  if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
                });
              }
            })
            .catch(function (err) {
              console.warn("[NP] Quantity sync failed:", err);
              if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
            });
        },
        true
      );
    }

    /* ───────── Sync quantity: Personalizer <-> Name Plate ───────── */

    setupQuantitySync() {
      if (document._npQuantitySyncBound) return;
      document._npQuantitySyncBound = true;

      var routes = window.MinimogSettings && window.MinimogSettings.routes;
      var baseUrl = routes && routes.cart_change_url ? routes.cart_change_url : "/cart/change";
      var changeUrl = baseUrl.indexOf(".js") === -1 ? baseUrl + ".js" : baseUrl;
      var root = (routes && routes.root) ? String(routes.root).replace(/\/$/, "") : "";
      var cartUrl = root ? root + "/cart.js" : "/cart.js";

      document.addEventListener(
        "change",
        function (e) {
          var input = e.target;
          if (input.type !== "number" || !input.closest("m-cart-items")) return;
          var line = parseInt(input.dataset.index || "0", 10);
          if (!line) return;
          var qty = parseInt(input.value, 10);
          if (isNaN(qty) || qty < 0) return;

          var cartItemsEl = document.querySelector("m-cart-items");
          if (!cartItemsEl) return;

          fetch(cartUrl)
            .then(function (r) {
              if (!r.ok) throw new Error("Cart fetch failed");
              return r.json();
            })
            .then(function (cart) {
              var item = cart.items[line - 1];
              if (!item) return;
              var pairId = item.properties && item.properties["_np_pair_id"];
              var isPersonalized = item.properties && item.properties["Number Plate Text"];
              var isNamePlate = String(item.variant_id) === String(NAME_PLATE_VARIANT_ID);
              if (!pairId && !isPersonalized && !isNamePlate) return;

              var pairLine = null;
              if (pairId) {
                for (var i = 0; i < cart.items.length; i++) {
                  if (i === line - 1) continue;
                  var other = cart.items[i];
                  if ((other.properties && other.properties["_np_pair_id"]) === pairId) {
                    pairLine = i + 1;
                    break;
                  }
                }
              } else if (isPersonalized) {
                var idx = line - 1;
                var prev = idx > 0 ? cart.items[idx - 1] : null;
                var next = idx < cart.items.length - 1 ? cart.items[idx + 1] : null;
                if (prev && String(prev.variant_id) === String(NAME_PLATE_VARIANT_ID)) pairLine = idx;
                else if (next && String(next.variant_id) === String(NAME_PLATE_VARIANT_ID)) pairLine = idx + 2;
                else {
                  for (var j = 0; j < cart.items.length; j++) {
                    if (String(cart.items[j].variant_id) === String(NAME_PLATE_VARIANT_ID)) {
                      pairLine = j + 1;
                      break;
                    }
                  }
                }
              } else if (isNamePlate) {
                var idx = line - 1;
                var prev = idx > 0 ? cart.items[idx - 1] : null;
                var next = idx < cart.items.length - 1 ? cart.items[idx + 1] : null;
                if (prev && prev.properties && prev.properties["Number Plate Text"]) pairLine = idx;
                else if (next && next.properties && next.properties["Number Plate Text"]) pairLine = idx + 2;
                else {
                  for (var k = 0; k < cart.items.length; k++) {
                    if (cart.items[k].properties && cart.items[k].properties["Number Plate Text"]) {
                      pairLine = k + 1;
                      break;
                    }
                  }
                }
              }
              if (!pairLine) return;

              e.stopPropagation();
              e.preventDefault();
              if (cartItemsEl.loading) cartItemsEl.loading.start();

              function doChange(lineNum, quantity) {
                return fetch(changeUrl, {
                  method: "POST",
                  headers: { "Content-Type": "application/json", Accept: "application/json" },
                  body: JSON.stringify({ line: lineNum, quantity: quantity }),
                }).then(function (r) {
                  return r.json().then(function (data) {
                    if (!r.ok || (data && data.errors)) throw new Error(data && (data.description || data.message));
                    return data;
                  });
                });
              }

              Promise.all([doChange(line, qty), doChange(pairLine, qty)])
                .then(function () {
                  if (cartItemsEl.loading) cartItemsEl.loading.finish();
                  document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
                })
                .catch(function (err) {
                  console.warn("[NP] Quantity sync failed:", err);
                  if (cartItemsEl.loading) cartItemsEl.loading.finish();
                });
            })
            .catch(function (err) {
              console.warn("[NP] Cart fetch failed:", err);
            });
        },
        true
      );
    }

    /* ───────── Sync quantity when Personalizer or Name Plate changed in cart ───────── */

    setupQuantitySync() {
      if (document._npQtySyncBound) return;
      document._npQtySyncBound = true;

      var routes = window.MinimogSettings && window.MinimogSettings.routes;
      var baseUrl = routes && routes.cart_change_url ? routes.cart_change_url : "/cart/change";
      var changeUrl = baseUrl.indexOf(".js") === -1 ? baseUrl + ".js" : baseUrl;
      var root = (routes && routes.root) ? String(routes.root).replace(/\/$/, "") : "";
      var cartUrl = root ? root + "/cart.js" : "/cart.js";

      document.addEventListener(
        "change",
        function (e) {
          var input = e.target;
          if (input.type !== "number" || !input.closest("m-cart-items")) return;
          var qtyInput = input.closest("m-quantity-input");
          if (!qtyInput) return;
          var line = parseInt(input.dataset.index || "0", 10);
          if (!line) return;
          var qty = parseInt(input.value, 10) || 0;

          var cartItemsEl = document.querySelector("m-cart-items");
          if (!cartItemsEl) return;

          fetch(cartUrl)
            .then(function (r) {
              if (!r.ok) throw new Error("Cart fetch failed");
              return r.json();
            })
            .then(function (cart) {
              var item = cart.items[line - 1];
              if (!item) return;
              var pairId = item.properties && item.properties["_np_pair_id"];
              var isPersonalized = item.properties && item.properties["Number Plate Text"];
              var isNamePlate = String(item.variant_id) === String(NAME_PLATE_VARIANT_ID);
              if (!pairId && !isPersonalized && !isNamePlate) return;

              var pairLine = null;
              if (pairId) {
                for (var i = 0; i < cart.items.length; i++) {
                  if (i === line - 1) continue;
                  var other = cart.items[i];
                  if (other.properties && other.properties["_np_pair_id"] === pairId) {
                    pairLine = i + 1;
                    break;
                  }
                }
              }
              if (!pairLine && (isPersonalized || isNamePlate)) {
                var idx = line - 1;
                var prev = idx > 0 ? cart.items[idx - 1] : null;
                var next = idx < cart.items.length - 1 ? cart.items[idx + 1] : null;
                if (isPersonalized) {
                  if (prev && String(prev.variant_id) === String(NAME_PLATE_VARIANT_ID)) pairLine = idx;
                  else if (next && String(next.variant_id) === String(NAME_PLATE_VARIANT_ID)) pairLine = idx + 2;
                } else if (isNamePlate) {
                  if (prev && prev.properties && prev.properties["Number Plate Text"]) pairLine = idx;
                  else if (next && next.properties && next.properties["Number Plate Text"]) pairLine = idx + 2;
                }
              }
              if (!pairLine || pairLine === line) return;

              e.stopPropagation();
              e.stopImmediatePropagation();
              if (cartItemsEl.loading) cartItemsEl.loading.start();

              function doChange(ln, q) {
                return fetch(changeUrl, {
                  method: "POST",
                  headers: { "Content-Type": "application/json", Accept: "application/json" },
                  body: JSON.stringify({ line: ln, quantity: q }),
                }).then(function (r) { return r.json(); });
              }

              var first = pairLine > line ? pairLine : line;
              var second = pairLine < line ? pairLine : line;
              Promise.all([doChange(first, qty), doChange(second, qty)])
                .then(function () {
                  if (cartItemsEl.loading) cartItemsEl.loading.finish();
                  document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
                })
                .catch(function (err) {
                  if (cartItemsEl.loading) cartItemsEl.loading.finish();
                  document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
                });
            })
            .catch(function () {});
        },
        true
      );
    }

    /* ───────── Sync quantity: Personalizer and Name Plate stay matched ───────── */

    setupQuantitySync() {
      if (document._npQtySyncBound) return;
      document._npQtySyncBound = true;

      var routes = window.MinimogSettings && window.MinimogSettings.routes;
      var changeUrl = routes && routes.cart_change_url ? routes.cart_change_url : "/cart/change";
      if (changeUrl.indexOf(".js") === -1) changeUrl += ".js";
      var root = (routes && routes.root) ? String(routes.root).replace(/\/$/, "") : "";
      var cartUrl = root ? root + "/cart.js" : "/cart.js";

      document.addEventListener(
        "change",
        function (e) {
          var input = e.target;
          if (input.type !== "number" || !input.closest("m-cart-items")) return;
          var line = parseInt(input.dataset.index || "0", 10);
          if (!line) return;

          var qty = parseInt(input.value, 10);
          if (isNaN(qty) || qty < 0) return;

          var cartItemsEl = document.querySelector("m-cart-items");
          if (!cartItemsEl) return;

          e.stopPropagation();
          e.preventDefault();
          if (cartItemsEl.loading) cartItemsEl.loading.start();

          fetch(cartUrl)
            .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error("Cart fetch failed")); })
            .then(function (cart) {
              var item = cart.items[line - 1];
              if (!item) {
                if (cartItemsEl.loading) cartItemsEl.loading.finish();
                return;
              }
              var pairId = item.properties && item.properties["_np_pair_id"];
              var isPersonalized = item.properties && item.properties["Number Plate Text"];
              var isNamePlate = String(item.variant_id) === String(NAME_PLATE_VARIANT_ID);
              var pairLine = null;

              if (pairId) {
                for (var i = 0; i < cart.items.length; i++) {
                  if (i === line - 1) continue;
                  var other = cart.items[i];
                  if ((other.properties && other.properties["_np_pair_id"]) === pairId) {
                    pairLine = i + 1;
                    break;
                  }
                }
              } else if (isPersonalized || isNamePlate) {
                var idx = line - 1;
                var prev = idx > 0 ? cart.items[idx - 1] : null;
                var next = idx < cart.items.length - 1 ? cart.items[idx + 1] : null;
                if (isPersonalized) {
                  if (prev && String(prev.variant_id) === String(NAME_PLATE_VARIANT_ID)) pairLine = idx;
                  else if (next && String(next.variant_id) === String(NAME_PLATE_VARIANT_ID)) pairLine = idx + 2;
                } else {
                  if (prev && prev.properties && prev.properties["Number Plate Text"]) pairLine = idx;
                  else if (next && next.properties && next.properties["Number Plate Text"]) pairLine = idx + 2;
                }
              }

              function doChange(ln, q) {
                return fetch(changeUrl, {
                  method: "POST",
                  headers: { "Content-Type": "application/json", Accept: "application/json" },
                  body: JSON.stringify({ line: ln, quantity: q }),
                }).then(function (r) { return r.json(); });
              }

              var refresh = function () {
                if (cartItemsEl.loading) cartItemsEl.loading.finish();
                document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
              };

              if (pairLine && pairLine !== line) {
                Promise.all([doChange(line, qty), doChange(pairLine, qty)])
                  .then(refresh)
                  .catch(function (err) {
                    console.warn("[NP] Quantity sync failed:", err);
                    refresh();
                  });
              } else {
                doChange(line, qty).then(refresh).catch(function (err) {
                  console.warn("[NP] Quantity change failed:", err);
                  refresh();
                });
              }
            })
            .catch(function (err) {
              console.warn("[NP] Quantity sync failed:", err);
              if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
            });
        },
        true
      );
    }

    /* ───────── Sync quantity: Personalizer <-> Name Plate ───────── */

    setupQuantitySync() {
      if (document._npQtySyncBound) return;
      document._npQtySyncBound = true;

      var routes = window.MinimogSettings && window.MinimogSettings.routes;
      var changeUrl = routes && routes.cart_change_url ? routes.cart_change_url : "/cart/change";
      changeUrl = changeUrl.indexOf(".js") === -1 ? changeUrl + ".js" : changeUrl;
      var root = (routes && routes.root) ? String(routes.root).replace(/\/$/, "") : "";
      var cartUrl = root ? root + "/cart.js" : "/cart.js";

      document.addEventListener("change", function (e) {
        var input = e.target;
        if (!input || input.type !== "number" || !input.dataset.index) return;
        if (!input.closest("m-quantity-input")) return;
        var inCart = input.closest("m-cart-items") || input.closest("m-cart") || input.closest("m-cart-drawer") || input.closest("form#cart-drawer-form");
        if (!inCart) return;

        var line = parseInt(input.dataset.index || "0", 10);
        if (!line) return;

        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 0) return;

        e.preventDefault();
        e.stopPropagation();

        var cartItemsEl = input.closest("m-cart-items") || document.querySelector("m-cart-items");
        if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.start();

        fetch(cartUrl)
          .then(function (r) {
            if (!r.ok) throw new Error("Cart fetch failed");
            return r.json();
          })
          .then(function (cart) {
            var item = cart.items[line - 1];
            if (!item) {
              if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
              return;
            }
            var pairId = item.properties && item.properties["_np_pair_id"];

            var pairLine = null;
            if (pairId) {
              for (var i = 0; i < cart.items.length; i++) {
                if (i === line - 1) continue;
                var other = cart.items[i];
                if (other.properties && other.properties["_np_pair_id"] === pairId) {
                  pairLine = i + 1;
                  break;
                }
              }
            }

            function doChange(lineNum, quantity, withSections) {
              var body = { line: lineNum, quantity: quantity };
              if (withSections) {
                body.sections = ["cart-drawer", "cart-template", "cart-count"];
                body.sections_url = window.location.pathname || "/";
              }
              return fetch(changeUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify(body),
              }).then(function (r) {
                return r.json().then(function (data) {
                  if (!r.ok || (data && data.errors)) throw new Error("Cart update failed");
                  return data;
                });
              });
            }

            function refresh(cartResponse) {
              if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
              if (cartResponse && cartResponse.sections) {
                if (typeof window.MinimogEvents !== "undefined" && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
                  window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: cartResponse });
                } else {
                  document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
                }
              } else {
                document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
              }
            }

            if (pairLine && pairLine !== line) {
              var first = pairLine > line ? pairLine : line;
              var second = pairLine < line ? pairLine : line;
              doChange(first, qty, false)
                .then(function () { return doChange(second, qty, true); })
                .then(function (cartResponse) { refresh(cartResponse); })
                .catch(function (err) {
                  console.warn("[NP] Quantity sync failed:", err);
                  refresh();
                });
            } else {
              doChange(line, qty, true).then(function (cartResponse) { refresh(cartResponse); }).catch(function (err) {
                console.warn("[NP] Quantity update failed:", err);
                refresh();
              });
            }
          })
          .catch(function (err) {
            console.warn("[NP] Quantity sync failed:", err);
            if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
          });
      }, true);
    }
  }

  /* ───────── Bootstrap ───────── */

  function initAll() {
    document.querySelectorAll(".np-personalizer").forEach(function (el) {
      if (!el._npInit) {
        el._npInit = true;
        new NumberPlatePersonalizer(el);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
